import { flags } from './flags';

export const validateTeaserList = flags.VALIDATE_SCHEMA
  ? async () =>
      await import('ajv').then(({ default: Ajv }) => {
        const ajv = new Ajv({ allErrors: true });

        const files = require.context(
          '@api/definitions',
          true,
          /\w+\.(schema).(json)$/,
          'sync'
        );

        files.keys().forEach(key => {
          ajv.addSchema(files(key));
        });

        const teaserListSchema = {
          $schema: 'http://json-schema.org/draft-07/schema',
          $id: 'http://bpb.de/schemas/teaser-list.schema.json',
          type: 'array',
          items: {
            $ref: 'definitions/teaser.schema.json',
          },
        };

        return ajv.compile(teaserListSchema);
      })
  : () => true;

// import teaserResponseSchema from '@api/teaser-response.schema.json';
// export const validateTeaserResponse = validate
//   ? ajv.compile(teaserResponseSchema)
//   : () => true;
